import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const canadaFields = {
  caSin: taxIdFieldConfig("CA", "caSin"),
  caConfirmSin: confirmTaxIdFieldConfig("CA", "caSin"),
};
